import React from 'react';

const SafePalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="533.333"
    height="533.333"
    version="1"
    viewBox="0 0 400 400"
  >
    <path
      d="M1720 3984c-418-61-792-244-1099-539-179-172-308-349-412-561-231-474-268-1013-103-1513 104-317 271-581 515-816C932 257 1305 75 1729 16c146-21 420-21 560 0 759 110 1384 633 1622 1356 77 234 84 285 84 628 0 280-2 313-23 408-86 389-270 729-542 1003-314 315-699 509-1141 573-132 20-435 19-569 0zm421-884l129-41v-139c0-77-3-140-7-140-5 0-64 18-132 40-69 21-128 37-133 34-4-3-8-147-8-320v-314h280v-259l-137-3-138-3-3-537c-1-296-4-538-5-538-3 0-129 50-214 85l-43 18v2073l133 41c72 22 136 41 141 42s67-17 137-39zm-495-345c-2-6-83-36-180-65l-176-54v-416h360v-605c0-333-2-605-4-605-3 0-40 19-83 42-146 78-247 151-343 247-145 146-190 248-190 433v98h260v-83c0-100 19-161 65-214l34-38-2 230-2 230-177 3-178 2v877l308 95 307 95 3-130c1-72 1-136-2-142zm1028 180c168-52 308-95 311-95s5-198 5-440v-440l-187-2-188-3-5-200-5-199-70-58c-61-52-161-118-179-118-3 0-6 371-6 825 0 471 4 825 9 825s146-43 315-95zm316-1197c-1-197-51-319-190-458-98-98-192-166-341-243-99-53-303-138-362-153l-28-6 3 137 3 137 101 42c270 114 456 250 523 383 17 35 21 60 21 141 0 54 3 102 7 105 3 4 64 7 135 7h128v-92z"
      transform="matrix(.1 0 0 -.1 0 400)"
    />
    <path
      d="M2610 2446v-226h110v419l-41 11c-22 6-47 14-55 17-12 4-14-28-14-221z"
      transform="matrix(.1 0 0 -.1 0 400)"
    />
  </svg>
);

export default SafePalIcon;
